export default "__VITE_ASSET__ade28629__"